// A horizontal ruler

export const Ruler = () => (
  <hr className="bg-secondary border-2 border-top border-secondary" />
);
